import { memo, useMemo } from 'react';

import { PrivateWorkspaceAgentInlineMonikerContent } from '~/components/v2/components/workspace/workspace-agent-panel/composer-host/read/PrivateWorkspaceAgentInlineMonikerContent';
import { useRegisterWorkspaceAgentAssetPillClipIds } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useRegisterWorkspaceAgentAssetPillClipIds';
import { synthesizeWorkspaceAgentPillsFromContent } from '~/components/v2/components/workspace/workspace-agent-panel/utils/synthesizeWorkspaceAgentPillsFromContent';

export type PrivateWorkspaceAgentMonikerTextProps = {
  value: string;
};

/** Elicitation prompts carry durable `@[entity:…]` strings, not `metadata.pills`, so chips are synthesized here. */
export const PrivateWorkspaceAgentMonikerText = memo(({ value }: PrivateWorkspaceAgentMonikerTextProps) => {
  const pills = useMemo(() => synthesizeWorkspaceAgentPillsFromContent(value), [value]);
  useRegisterWorkspaceAgentAssetPillClipIds(pills);

  return <PrivateWorkspaceAgentInlineMonikerContent emptyPlaceholder={null} pills={pills} value={value} />;
});

PrivateWorkspaceAgentMonikerText.displayName = 'PrivateWorkspaceAgentMonikerText';
